module.exports = __webpack_public_path__ + "static/media/solar-panel.3085a581.jpg";